import Header from "../components/Header";
import React, { useState, useEffect } from "react";
import Flashcards from "../components/Flashcards";
import { useLocation } from "react-router-dom";
import { Button } from "@mantine/core";
import axios from "axios";
import { withAuth } from "./withAuth";
import { API_URL } from "../config";

function CardPage() {
  const location = useLocation();
  const { setId } = location.state;

  const [flashcards, setFlashcards] = useState([]);
  const [currentCard, setCurrentCard] = useState(0);
  const [nextBtnState, setNextBtnState] = useState(false);
  const [prevBtnState, setPrevBtnState] = useState(false);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    axios
      .get(`${API_URL}/set/${userId}/${setId}`)
      .then((response) => {
        setFlashcards(response.data.data[0].flashcards);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    if (currentCard === flashcards.length - 1) {
      setNextBtnState(true);
      setPrevBtnState(false);
    } else if (currentCard === 0) {
      setPrevBtnState(true);
      setNextBtnState(false);
    } else {
      setNextBtnState(false);
      setPrevBtnState(false);
    }
  });
  const onNextClick = () => {
    if (currentCard < flashcards.length - 1) {
      setCurrentCard(currentCard + 1);
    }
  };

  const onPrevClick = () => {
    if (currentCard <= flashcards.length - 1 && currentCard > 0) {
      setCurrentCard(currentCard - 1);
    }
  };

  return (
    <div className="home-container">
      <Header />
      <Flashcards flashcards={flashcards} current={currentCard} />
      <Button
        variant="light"
        className="prevBtn"
        color="orange"
        radius="md"
        size="lg"
        onClick={onPrevClick}
        disabled={prevBtnState}
      >
        Prev
      </Button>
      <Button
        variant="light"
        className="nextBtn"
        color="orange"
        radius="md"
        size="lg"
        disabled={nextBtnState}
        onClick={onNextClick}
      >
        Next
      </Button>
    </div>
  );
}

export default withAuth(CardPage);
